import { render, staticRenderFns } from "./addShop.vue?vue&type=template&id=03e310fe&scoped=true&"
import script from "./addShop.vue?vue&type=script&lang=js&"
export * from "./addShop.vue?vue&type=script&lang=js&"
import style0 from "./addShop.vue?vue&type=style&index=0&id=03e310fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e310fe",
  null
  
)

export default component.exports